@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.styledModal {
  [data-modal-container] {
    width: 800px;
  }

  [data-modal-buttons] {
    margin-left: 0;
    margin-right: 0;
    padding: 20px 20px 0;
    border-top: 1px solid var(--border-soft);
  }

  @include respond-to('max-sm') {
    [data-modal-container] {
      width: 80%;
    }
  }
}

.content {
  padding-left: 20px;
  padding-right: 20px;
}

.sources {
  border: 1px solid var(--border-soft);
  @include border-radius-r2;
}
